import React from 'react';
import { useBreakpoint } from '../hooks/useBreakpoint';

const ITEMS = [
  { icon: '💵', text: 'COD Available' },
  { icon: '↩', text: '7-Day Easy Exchange & Returns' },
  { icon: '🚚', text: 'Pan-India Express Shipping (3–5 Days)' },
  { icon: '✓', text: 'Free Shipping above ₹999' },
];

export default function TrustBar() {
  const { isMobile } = useBreakpoint();

  return (
    <div style={{
      background: '#2C2C2C',
      padding: isMobile ? '10px 12px' : '10px 24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: isMobile ? 10 : 40,
      flexWrap: 'wrap',
    }}>
      {ITEMS.map((item, i) => (
        <span key={i} style={{
          color: '#fff',
          fontSize: isMobile ? 11 : 13,
          fontWeight: 500,
          letterSpacing: 0.3,
          whiteSpace: 'nowrap',
        }}>
          <span style={{ marginRight: 5 }}>{item.icon}</span>
          {item.text}
        </span>
      ))}
    </div>
  );
}
